import {
  Button,
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { SUPPORT_URL } from "constants/global";
import React, { type ComponentProps, useRef } from "react";

export type HelpCenterButtonProps = {
  canAccess: boolean;
  onGetToken: () => Promise<string | null>;
} & Omit<ComponentProps<typeof Button>, "onClick" | "variant"> &
  WithStyles<typeof styles>;

const HelpCenterButton = ({
  canAccess,
  classes,
  className,
  onGetToken,
  ...rest
}: HelpCenterButtonProps) => {
  const formRef = useRef<HTMLFormElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = async () => {
    const token = await onGetToken();

    if (inputRef.current == null || formRef.current == null || token == null) {
      return;
    }

    // add the JWT to a hidden form
    inputRef.current.value = token;
    formRef.current.submit();
  };

  if (!canAccess) {
    return null;
  }

  return (
    <>
      <button
        className={`${classes.button} ${className || ""}`}
        onClick={handleClick}
        {...rest}
      >
        <SupportAgentIcon aria-hidden="true" className={classes.icon} />
      </button>
      <form ref={formRef} action={SUPPORT_URL} method="post" target="_blank">
        <input ref={inputRef} type="hidden" name="jwt" />
      </form>
    </>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    button: {
      backgroundColor: "transparent",
      borderRadius: "50%",
      minWidth: 0,
      padding: "12px",
      transition: "filter 0.3s",
      width: "fit-content",
      border: "none",
      cursor: "pointer",
      color: "#616161",
      "&:hover, &:active": {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        filter: "brightness(0.8)",
      },
    },
    icon: {
      fill: "#616161",
      fontSize: "24px !important",
    },
  });

export default withStyles(styles)(HelpCenterButton);
